import { useEffect } from 'react';

import { notificationController } from '@app/controllers/notificationController';
import { useResponsive } from '@app/hooks/useResponsive';

export const useResponsiveNotificationController = (): void => {
  const { mobileOnly, tabletOnly } = useResponsive();

  useEffect(() => {
    if (mobileOnly) {
      notificationController.setViewport('mobile');
      return;
    }

    if (tabletOnly) {
      notificationController.setViewport('tablet');
      return;
    }

    notificationController.setViewport('desktop');
  }, [mobileOnly, tabletOnly]);
};
